import * as FormConfig from './FormConfig'
import * as SelectionConfig from './SelectionConfig';
import * as StepConfig from './StepConfig';

const configs = Object.assign({}, FormConfig, SelectionConfig, StepConfig);

class ConfigCenter {
    static getConfig(name) {
        return configs[name] || null;
    }
}

export default ConfigCenter;